export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const URL_REGEX =  
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

export const PASSWORD_REGEX =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export const PRODUCTION_URL =
  "https://europe-west3-products-a14cf.cloudfunctions.net/app/";
export const DEVELOPMENT_URL =
  "http://127.0.0.1:5001/fryda-testing/europe-west3/app/";
    
export const TEST_ENVIRONMENT = true;
